module.exports = __webpack_public_path__ + "static/img/banner_2_no_red.490e3246.jpg";